import { render, staticRenderFns } from "./mail.vue?vue&type=template&id=042ef8c9"
var script = {}
import style0 from "./mail.vue?vue&type=style&index=0&id=042ef8c9&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports